import { captureException } from '@zenbusiness/application-commons-logging';

import { getWfgIRName } from '../utils/orderTask';

export const nameMap = {
  '1800_accountant': (_, __, fm) => fm({ id: 'orderView.taskName.taxSavingsConsultation' }),
  adjustment: (_, __, fm) => fm({ id: 'orderView.taskName.adjustment' }),
  annual_report_service: (_, __, fm) => fm({ id: 'orderView.taskName.annualReportService' }),
  bank_of_america_offer: (_, __, fm) => fm({ id: 'orderView.taskName.bankOfAmericaOffer' }),
  banking: (_, __, fm) => fm({ id: 'orderView.taskName.banking' }),
  banking_resolution: (_, __, fm) => fm({ id: 'orderView.taskName.bankingResolution' }),
  basic_email: (_, __, fm) => fm({ id: 'orderView.taskName.businessEmail' }),
  beneficial_ownership_filing: (_, __, fm) => fm({ id: 'orderView.taskName.beneficialOwnership' }),
  bof_modification: (_, __, fm) => fm({ id: 'orderView.taskName.beneficialOwnershipModification' }),
  business_kit: (_orderTask, businessEntityType, fm) => (businessEntityType === 'llc' ? fm({ id: 'orderView.taskName.llcBusinessKit' }) : fm({ id: 'orderView.taskName.corpBusinessKit' })),
  business_license_report: (_, __, fm) => fm({ id: 'orderView.taskName.businessLicenseReport' }),
  change_of_registered_agent: ({ orderTaskData: { jurisdiction } = {}, orderTaskJurisdiction }, _, fm) => `${fm({ id: 'orderView.taskName.changeOfRegisteredAgent' })} (${jurisdiction || orderTaskJurisdiction})`,
  corp_amendment: (_, __, fm) => fm({ id: 'orderView.taskName.corpAmendment' }),
  corp_annual_report: ({ orderTaskData: { jurisdiction } = {} }, _, fm) => `${fm({ id: 'orderView.taskName.annualReport' })} (${jurisdiction})`,
  corp_formation: (_, __, fm) => fm({ id: 'orderView.taskName.corpFormation' }),
  corporate_docs: (_, __, fm) => fm({ id: 'orderView.taskName.documentTemplates' }),
  credit_card_offer: (_, __, fm) => fm({ id: 'orderView.taskName.creditCardOffer' }),
  dao_designation: (_, __, fm) => fm({ id: 'orderView.taskName.daoFormation' }),
  dba_compliance: (_, __, fm) => fm({ id: 'orderView.taskName.dbaCompliance' }),
  dba_entity: (_, __, fm) => fm({ id: 'orderView.taskName.dbaRegistration' }),
  dissolution: (_, __, fm) => fm({ id: 'orderView.taskName.dissolution' }),
  domain_name_privacy: (_, __, fm) => fm({ id: 'orderView.taskName.domainPrivacy' }),
  domain_name_reg: (_, __, fm) => fm({ id: 'orderView.taskName.domainName' }),
  ein_business_docs_bundle: (_, __, fm) => fm({ id: 'orderView.taskName.einBundle' }),
  ein_creation: (_, __, fm) => fm({ id: 'orderView.taskName.ein' }),
  entity_name_reservation: (_, __, fm) => fm({ id: 'orderView.taskName.entityNameReservation' }),
  expedite: (_, __, fm) => fm({ id: 'orderView.taskName.expediteFiling' }),
  expedite_to_rush_upgrade: (_, __, fm) => fm({ id: 'orderView.taskName.expediteToRush' }),
  extra_credits: (_, __, fm) => fm({ id: 'orderView.taskName.extraCredits' }),
  future_file_date: (_, __, fm) => fm({ id: 'orderView.taskName.futureFilingDate' }),
  initial_cpa_screening: (_, __, fm) => fm({ id: 'orderView.taskName.freeAccountingConsultation' }),
  llc_amendment: (_, __, fm) => fm({ id: 'orderView.taskName.llcAmendment' }),
  llc_annual_report: ({ orderTaskData: { jurisdiction } = {} }, _, fm) => `${fm({ id: 'orderView.taskName.annualReport' })} (${jurisdiction})`,
  llc_formation: (_, __, fm) => fm({ id: 'orderView.taskName.stateFilingFee' }),
  logo_kit: (_, __, fm) => fm({ id: 'orderView.taskName.logoKit' }),
  ny_publication: ({ orderTaskData: { jurisdiction } = {} }, _, fm) => jurisdiction && `${jurisdiction} ${fm({ id: 'orderView.taskName.publication' })}`,
  ongoing_bof_compliance: (_, __, fm) => fm({ id: 'orderView.taskName.ongoingBeneficialOwnership' }),
  operating_agreement: (_, __, fm) => fm({ id: 'orderView.taskName.operatingAgreement' }),
  personal_credit_monitoring: (_, __, fm) => fm({ id: 'orderView.taskName.creditMonitoring' }),
  priority: (_, __, fm) => fm({ id: 'orderView.taskName.expediteFiling' }),
  protection_services: (_, __, fm) => fm({ id: 'orderView.taskName.additionalServices' }),
  registered_agent_service: ({ orderTaskData: { isCora, jurisdiction } = {} }, _, fm) => {
    const base = fm({ id: 'orderView.taskName.registeredAgent' });
    return isCora ? `${base.replace(' Service', '')} (${jurisdiction})` : base;
  },
  reinstatement: (_, __, fm) => fm({ id: 'orderView.taskName.reinstatement' }),
  resignation: (_, __, fm) => fm({ id: 'orderView.taskName.resignation' }),
  rush: (_, __, fm) => fm({ id: 'orderView.taskName.rushFiling' }),
  s_corp_conversion: (_, __, fm) => fm({ id: 'orderView.taskName.sCorpConversion' }),
  s_corp_designation: (_, __, fm) => fm({ id: 'orderView.taskName.sCorpDesignation' }),
  standard_good_standing: (_, __, fm) => fm({ id: 'orderView.taskName.goodStanding' }),
  static_website: (_, __, fm) => fm({ id: 'orderView.taskName.website' }),
  tax_filing: (_, __, fm) => fm({ id: 'orderView.taskName.taxFiling' }),
  tax_preparation: (_, __, fm) => fm({ id: 'orderView.taskName.taxPrepFiling' }),
  unknown: (_, __, fm) => fm({ id: 'orderView.taskName.additionalServices' }),
  virtual_business_address: (_, __, fm) => fm({ id: 'orderView.taskName.virtualMailingAddress' }),
  website_tools_bundle: ({ displayName }) => displayName,
  wfg_initial_report: ({ jurisdiction }, _, fm) => `${getWfgIRName(jurisdiction, fm)} Service`,
  worry_free_service: (_, __, fm) => fm({ id: 'orderView.taskName.worryFreeCompliance' }),
  worry_free_service_advanced_addon: (_, __, fm) => fm({ id: 'orderView.taskName.worryFreeComplianceAdvanced' }),
  zb_banking_preferred: (_, __, fm) => fm({ id: 'orderView.taskName.zbBankingPreferred' }),
  zb_tax_advice: (_, __, fm) => fm({ id: 'orderView.taskName.unlimitedTaxAdvice' }),
  zb_tax_advice_biztax_prep: (_, __, fm) => fm({ id: 'orderView.taskName.unlimitedTaxAdviceAnnual' }),
  zb_biztax_prep_2023: (_, __, fm) => fm({ id: 'orderView.taskName.annualBusinessTaxFiling' }),
  zb_money_essential: (_, __, fm) => fm({ id: 'orderView.taskName.moneyEssential' }),
  zb_money_pro: (_, __, fm) => fm({ id: 'orderView.taskName.moneyPro' }),
  zb_quarterly_tax_planning: (_, __, fm) => fm({ id: 'orderView.taskName.quarterlyTaxPlanning' }),
  zb_tax_full_service_biz_per_llc: (_, __, fm) => fm({ id: 'orderView.taskName.singleMemberTaxPrep' })
};

const filterTasks = ['free_year_package', 'standard', 'the_starter_package'];

const planNameMap = (fm) => ({
  starter_plan: fm({ id: 'orderView.planName.starter' }),
  pro_plan: fm({ id: 'orderView.planName.pro' }),
  premium_plan: fm({ id: 'orderView.planName.premium' }),
  subscription_plan: fm({ id: 'orderView.planName.monthlySubscription' })
});

function mapPlanName(str, fm) {
  return planNameMap(fm)[str];
}

export const getDisplayName = (task, businessEntityType, fm) => {
  const { orderTaskType: type, displayName = '' } = task;

  // handle plan names
  const plan = type.match(/(starter_plan|pro_plan|premium_plan|subscription_plan)/);
  if (plan) {
    return mapPlanName(plan[0], fm);
  }

  if (nameMap[type]) {
    return nameMap[type](task, businessEntityType, fm);
  }
  // if not a plan or if display name is falsy, send an error
  if (!(displayName || filterTasks.includes(type))) {
    captureException(new Error(`Order task ${type} missing from order support`), {
      tags: {
        frontend: 'dashboard-ui'
      }
    });
  }

  return displayName;
};
